<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
   

        <material-card
          title="Request New Account"
          text="EMN Logistic"
          color="primary">

           <v-container  v-if="isCreated" grid-list-md>
              <slot name="prebody"></slot>
              <v-layout wrap>

                <v-flex xs6 sm12 md12>
                    <br><br><br><br><br><br><br><br><br><br><br>
                    <font size="+2">The request was successfully saved and will be processed as soon as possible. </font><br>
                    <font size="+2">You will receive a confirmation email when your account is activated</font>
                    <br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                </v-flex>
              </v-layout>
           </v-container>

         
          <v-form
            v-if="!isCreated"
            class="mt-4"
            ref="form"
            _lazy-validation
            v-model="validForm"
            autocomplete="off"
            role="presentation">
            <v-container grid-list-md>
              <slot name="prebody"></slot>
              <v-layout wrap>

                <v-flex xs6 sm6 md6>
                     <v-text-field
                      label="Name"
                      v-model="account.name"
                       :rules="validators.account.name"
                    ></v-text-field>
                </v-flex>


                <v-flex xs6 sm6 md6>
                     <v-text-field
                      label="Surname"
                      v-model="account.surname"
                       :rules="validators.account.surname"
                    ></v-text-field>
                </v-flex>


                 <v-flex xs6 sm6 md6>
                     <v-text-field
                      label="Email"
                      v-model="account.email"
                       :rules="validators.account.email"
                    ></v-text-field>
                </v-flex>

                <!--v-flex xs6 sm6 md6>
                     <v-text-field
                      label="Username"
                      disabled
                      readonly
                      v-model="account.username"
                    ></v-text-field>
                </v-flex-->


                 <v-flex xs12 sm6 md6>

                  <v-radio-group
                    v-model="chooseIam"
                    :rules="[v => !!v || 'Choose where you are']"
                    row>
                     <template v-slot:label>
                      <div>Your user profile</div>
                    </template>
                    <v-radio
                      label="Site"
                      value="Site"></v-radio>
                    <v-radio
                      label="Laboratory"
                      value="Lab"></v-radio>
                  </v-radio-group>

                 </v-flex>


                 <v-flex xs12 sm6 md6 v-if="imSite && chooseIam">
                 <app-autocomplete
                      label="Site"
                      entity="public/site"
                      itemText="factor_label"
                      itemValue="id"
                      :filters="(val) => { return {'factor_label':  '%' + val + '%'} }"
                      v-model="account.site_id"
                      :rules="validators.account.site_id"
                    ></app-autocomplete>
                </v-flex>


                 <v-flex xs12 sm6 md6 v-if="!imSite && chooseIam">
                 <app-autocomplete
                      label="Lab"
                      entity="public/lab"
                      itemText="name"
                      itemValue="id"
                      :filters="(val) => { return {'name':  '%' + val + '%'} }"
                      v-model="account.lab_id"
                      :rules="validators.account.lab_id"
                    ></app-autocomplete>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Hospital Name"
                      v-model="account.hospital_name"
                       :rules="validators.account.hospital_name"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Address"
                      v-model="account.address"
                       :rules="validators.account.address"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Postcode and Town"
                      v-model="account.postcode_town"
                       :rules="validators.account.postcode_town"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Further details: Floor - Lift number (if applicable) - Department name"
                      v-model="account.further_details"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Contact Person"
                      v-model="account.contact_person"
                       :rules="validators.account.contact_person"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Contact email"
                      v-model="account.contact_email"
                       :rules="validators.account.contact_email"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm6 md6>
                     <v-text-field
                      label="Phone"
                      v-model="account.contact_phone"
                       :rules="validators.account.contact_phone"
                    ></v-text-field>
                </v-flex>


                <v-flex xs12 sm12 md12>
                  In compliance with the European General Data Protection
                  Regulation (GDPR) n. 2016/679, I hereby authorize EMN
                  Logistic to use and process my personal details
                  contained in this document.
                  <a :href="gdprLink" target="_blank"
                    >Please read the GDPR</a
                  >
                  <v-checkbox
                    label="I Agree"
                    v-model="account.privacy_agree"
                    :rules="validators.account.privacy"
                  ></v-checkbox>
                </v-flex>


                <v-flex xs12 sm12 md12>
                  <a :href="guidelinesLink" target="_blank"
                    >Please read the Guidelines</a
                  >
                  <v-checkbox
                    label="You confirm that you read the Guidelines"
                    v-model="account.guidelines_agree"
                    :rules="validators.account.guidelines"
                  ></v-checkbox>
                </v-flex>


                 <v-flex xs12 text-right>
                    <v-btn
                      class="mx-1 font-weight-light"
                      color="success"
                      :disabled="!validForm"
                      @click="save()">Save</v-btn>
                  </v-flex>


                <v-flex xs12 sm12 md12 text-right>
                </v-flex>

                <v-flex xs12 sm12 md12 text-right>
                </v-flex>

                <v-flex xs12 sm12 md12 text-right>
                </v-flex>
               

               
              </v-layout>
            </v-container>
          </v-form>

        </material-card>
      
    </v-flex>

  </v-container>
</template>

<script>
import { post } from '@/api/base_entity'
import validators from '../../utils/validators.js'

export default {
  inheritAttrs: false,
  data () {
    return {
      validForm:false,
      validators,
      loading: false,
      account: {privacy_agree:false},
      chooseIam: null,
      isCreated: false
    }
  },
  async created () {
  },
  async mounted () {
  
  },
  computed: {
    imSite() {
      return this.chooseIam == 'Site' ? true : false
    },
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
    gdprLink() {
      return "https://www.emnlogistic.com/storage/repository/emnlogistic/Privacy_EMN_Logistic.pdf"
    },
    guidelinesLink() {
      return "/EMN_LOGISTIC_guide_v3.1_230323.pdf"
    },
  },
  methods: {
    save() {
      this.account.role = this.chooseIam
      post("/request_account", this.account).then( () => {
        this.isCreated = true
        this.$root.$emit('openSnackbar', {
          message: 'Request send successfully',
          color: 'success'
        })
      }).catch( (e) => {
        var err = '';
        if(e.response.data.error_details) {
          err = Object.values(e.response.data.error_details).join('\n')
        } else {
          err = e.response.data.message
        }
        this.$root.$emit('openSnackbar', {
          message: 'An error occurred during new request account : ' + err,
          color: 'error'
        })

      })
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
